import React from "react";
import { LayoutGrid, List as ListIcon } from "lucide-react";

// =====================================================================
// Cards ↔ List view toggle for the Requests pages. Labeled (icon + text)
// so it is discoverable next to the filters/tabs — an earlier icon-only
// version was easy to miss. Shared by the AGENT/agency view
// (AgentTenders.js) and the CLUB view (ClubTendersMainContent) so both
// behave identically — single source of truth, no divergent markup.
//
// Props:
//   value    — "card" | "list"
//   onChange — called with "card" | "list"
// =====================================================================
const ViewModeToggle = ({ value, onChange }) => {
  const current = value === "list" ? "list" : "card";
  const base =
    "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition";
  const active = "bg-[#E9F3FF] text-[#2283FF] font-medium";
  const idle = "text-[#1E1E1ECC] hover:bg-gray-50";
  return (
    <div className="inline-flex items-center border border-[#E6E6E6] rounded-lg p-0.5">
      <button
        type="button"
        onClick={() => onChange("card")}
        aria-pressed={current === "card"}
        aria-label="Card view"
        title="Card view"
        className={`${base} ${current === "card" ? active : idle}`}
      >
        <LayoutGrid className="w-4 h-4" />
        <span>Cards</span>
      </button>
      <button
        type="button"
        onClick={() => onChange("list")}
        aria-pressed={current === "list"}
        aria-label="List view"
        title="List view"
        className={`${base} ${current === "list" ? active : idle}`}
      >
        <ListIcon className="w-4 h-4" />
        <span>List</span>
      </button>
    </div>
  );
};

export default ViewModeToggle;
